class SendWa{
    //1. Describe and initiate our object
    constructor() {
        this.waAdmin = '6285858575069'
        // Services
        this.webDev = document.getElementById('services-web-development');
        this.mobileDev = document.getElementById('services-mobile-application');
        this.seo = document.getElementById('services-seo');
        this.logoDesign = document.getElementById('services-logo-design');
        this.grapichDesign = document.getElementById('services-graphic-design');
        this.instagram = document.getElementById('services-instagram');
        this.googleAds = document.getElementById('services-google-ads');

        // Budgets
        this.budgetUnder5m = document.getElementById('budgets-under-5M');
        this.budget5_15m = document.getElementById('budgets-5-15M');
        this.budget15_25m = document.getElementById('budgets-15-25M');
        this.budget25_50m = document.getElementById('budgets-25-50M');
        this.budgetOver50m = document.getElementById('budgets-over-50M');
        this.budgetOthers = document.getElementById('budgets-others');

        // form data
        this.name = document.getElementById('name')
        this.email = document.getElementById('email')
        this.phone = document.getElementById('phone')
        this.information = document.getElementById('information')
        this.sendWa = document.getElementById('send-wa')

        this.events()
    }

    // 2. Events
    events() {
        this.sendWa.addEventListener("click", () => this.sendToWa())
    }

    // 3. methods (function, action...)
    getServicesCheckBoxValue() {

        let services = '';
        if (this.webDev.checked === true) {
            services += this.webDev.value + ', ';
        }

        if (this.mobileDev.checked === true) {
            services += this.mobileDev.value + ', ';
        }

        if (this.seo.checked === true) {
            services += this.seo.value + ', ';
        }

        if (this.logoDesign.checked === true) {
            services += this.logoDesign.value + ', ';
        }

        if (this.grapichDesign.checked === true) {
            services += this.grapichDesign.value + ', ';
        }

        if (this.instagram.checked === true) {
            services += this.instagram.value + ', ';
        }

        if (this.googleAds.checked === true) {
            services += this.googleAds.value + ', ';
        }

        return services;
    }
    getBudgetsCheckBoxValue() {

        let budgets = '';
        if (this.budgetUnder5m.checked === true) {
            budgets += this.budgetUnder5m.value + ', ';
        }

        if (this.budget5_15m.checked === true) {
            budgets += this.budget5_15m.value + ', ';
        }

        if (this.budget15_25m.checked === true) {
            budgets += this.budget15_25m.value + ', ';
        }

        if (this.budget25_50m.checked === true) {
            budgets += this.budget25_50m.value + ', ';
        }

        if (this.budgetOver50m.checked === true) {
            budgets += this.budgetOver50m.value + ', ';
        }

        if (this.budgetOthers.checked === true) {
            budgets += this.budgetOthers.value + ', ';
        }

        return budgets;
    }
    sendToWa() {
        let services = this.getServicesCheckBoxValue();
        let budgets = this.getBudgetsCheckBoxValue();
        let name = this.name.value;
        let email = this.email.value;
        let phone = this.phone.value;
        let information = this.information.value;

        console.log(name, email, phone, information, services)

        window.open(`whatsapp://send?phone=${this.waAdmin} &text=Halo PixelMedia, %0D%0AServices : ${services}%0D%0ABudgets : ${budgets}%0D%0AName : ${name}%0D%0AEmail : ${email}%0D%0APhone Number : ${phone}%0D%0AInformation : ${information}`)

    }

}

export default SendWa
